/* tslint:disable */
/* eslint-disable */
/* @relayHash 9951e8dabb46431923c365989f541aab */

import { ConcreteRequest } from "relay-runtime";
export type USER_ROLE = "ADMIN" | "COMMENTER" | "MEMBER" | "MODERATOR" | "STAFF" | "%future added value";
export type InviteUsersInput = {
    emails: Array<string>;
    role: USER_ROLE;
    clientMutationId: string;
};
export type InviteUsersMutationVariables = {
    input: InviteUsersInput;
};
export type InviteUsersMutationResponse = {
    readonly inviteUsers: {
        readonly clientMutationId: string;
        readonly invites: ReadonlyArray<{
            readonly id: string;
            readonly email: string;
        } | null>;
    };
};
export type InviteUsersMutation = {
    readonly response: InviteUsersMutationResponse;
    readonly variables: InviteUsersMutationVariables;
};



/*
mutation InviteUsersMutation(
  $input: InviteUsersInput!
) {
  inviteUsers(input: $input) {
    clientMutationId
    invites {
      id
      email
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any)
    ], v1 = [
        ({
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "InviteUsersPayload",
            "kind": "LinkedField",
            "name": "inviteUsers",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Invite",
                    "kind": "LinkedField",
                    "name": "invites",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "email",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any)
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "InviteUsersMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "InviteUsersMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "id": "9951e8dabb46431923c365989f541aab",
            "metadata": {},
            "name": "InviteUsersMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = 'de744cb7e39f30cc173d52b014b49848';
export default node;
